import { createSelector } from "reselect";
import { patientsSectionSelector } from "../patients_section_selector";

export const checkedDischargedOptionSelector = createSelector(
  patientsSectionSelector,
  patientsSection => {
    return patientsSection.checkedDischargedOption;
  }
);
